module.exports = {"StatusCode":200,"Payload":"[{\"days\":200,\"date\":\"2020-03-07T18:49:25.267Z\",\"canChangeAutoRenew\":true,\"expired\":false}]"}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/checkDomainExpiry.json
// module id = qyvC
// module chunks = 0